import React from 'react';

function Maintenance() {
  return (
    <div className="page-maintenance" style={{ padding: '4rem 1.5rem', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>

      <div
        style={{
          maxWidth: '650px',
          width: '100%',
          background: 'var(--bg-secondary)',
          border: '1px solid var(--border-color)',
          borderRadius: '16px',
          padding: '3.5rem 2.5rem',
          textAlign: 'center',
          boxShadow: 'var(--card-shadow)'
        }}
      >
        {/* Status Indicator */}
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem', background: 'rgba(255, 102, 0, 0.08)', padding: '0.4rem 1rem', borderRadius: '30px', marginBottom: '2rem' }}>
          <span className="spinner" style={{ width: '12px', height: '12px', border: '2px solid var(--accent-color)', borderTopColor: 'transparent', display: 'inline-block' }}></span>
          <span style={{ fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: 'var(--accent-color)' }}>
            Scheduled Enhancements
          </span>
        </div>

        {/* Header Title */}
        <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', fontWeight: 500, margin: '0 0 1rem 0' }}>
          Thank you for visiting Saveera Biotech.
        </p>

        <h1 style={{ fontFamily: 'var(--font-title)', fontSize: '2.4rem', fontWeight: 900, textTransform: 'uppercase', color: 'var(--text-primary)', marginBottom: '1.5rem', lineHeight: '1.2' }}>
          Website Under Maintenance
        </h1>

        <p style={{ color: 'var(--accent-color)', fontWeight: 600, fontSize: '1.05rem', marginBottom: '2rem' }}>
          * A few services might be temporarily unavailable during this period.
        </p>

        {/* Details Copy */}
        <div style={{ textAlign: 'left', background: 'rgba(0, 0, 0, 0.02)', padding: '1.8rem', borderRadius: '8px', borderLeft: '4px solid var(--accent-color)', marginBottom: '2.5rem' }}>
          <p style={{ color: 'var(--text-secondary)', fontSize: '1.05rem', lineHeight: '1.7', marginBottom: '1rem', fontWeight: 500 }}>
            Our website is currently undergoing scheduled maintenance and system enhancements to improve performance and user experience.
          </p>
          <p style={{ color: 'var(--text-secondary)', fontSize: '1.05rem', lineHeight: '1.7', margin: 0 }}>
            We are working diligently to restore full access as quickly as possible.
          </p>
        </div>

        {/* Contact info Block */}
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '2rem' }}>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.98rem', lineHeight: '1.6', margin: 0 }}>
            If you require assistance or have any inquiries,
          </p>
          <p style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', marginTop: '0.5rem' }}>
            Please contact us: <a href="mailto:info@saveerabiotech.com" style={{ color: 'var(--accent-color)', textDecoration: 'none' }}>info@saveerabiotech.com</a>
          </p>
        </div>

      </div>

    </div>
  );
}

export default Maintenance;
